import React from 'react';
import MenuContainer, { ConfigButton } from './style';

export default function MenuClose({ nameProfile }) {
  return (
    <MenuContainer>
      <MenuContainer.Profile>
        <img id="profilePhoto" src="/images/avatar-icon.svg" alt={nameProfile} />
        <h3>{nameProfile}</h3>
        <ConfigButton to="/painel-usuario">
          <img id="configuration" src="/images/icons/configuration-white.svg" alt="configuration" />
        </ConfigButton>
      </MenuContainer.Profile>
    </MenuContainer>
  );
}
